import React, { Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LoadingButton from '../../../common/LoadingButton';

export default function RemoveUserModal({ isOpen, toggle, className, action, selectedUser, pending, removeStep, removeUserMesageAction }) {
  const toggleMethod = () => {
    toggle();
  };

  const renderMessageForEnabledUsers = () => (
    <Fragment>
      <ModalBody>
        User has to be <strong>disabled</strong> first in order to delete.
      </ModalBody>
      <ModalFooter>
        <Button color="c-secondary" onClick={toggleMethod}>Go Back</Button>
      </ModalFooter>
    </Fragment>
  );

  const renderMessageForDisabledUsers = () => (
    <Fragment>
      <ModalBody>
        Are you sure you want remove user <strong>{selectedUser && selectedUser.username}</strong>?
      </ModalBody>
      <ModalFooter>
        <LoadingButton loading={pending} disabled={pending} color="danger" onClick={action}>Remove</LoadingButton>{' '}
        <Button color="c-secondary" onClick={toggleMethod}>Cancel</Button>
      </ModalFooter>
    </Fragment>
  );

  const renderMessageForAppUnassignment = () => (
    <Fragment>
      <ModalBody>
        User <strong>{selectedUser && selectedUser.username}</strong> has been removed olny from your application.<br />
        To remove user completely contact with administrator.
      </ModalBody>
      <ModalFooter>
        <LoadingButton color="c-primary" onClick={removeUserMesageAction}>Ok</LoadingButton>{' '}
      </ModalFooter>
    </Fragment>
  )

  return (
    <Modal isOpen={isOpen} toggle={toggleMethod} className={className}>
      <ModalHeader toggle={toggleMethod}>Remove user</ModalHeader>
      {(selectedUser && selectedUser.isDisabled) ? ( removeStep===2 ? renderMessageForAppUnassignment() : renderMessageForDisabledUsers()) : renderMessageForEnabledUsers()}
    </Modal>
  )
}